/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Equipment_NoneInputs */

const en_us2_profile_equipment_none = /** @type {(inputs: Profile_Equipment_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing ticked`)
};

const pt_br2_profile_equipment_none = /** @type {(inputs: Profile_Equipment_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada marcado`)
};

const es_419_profile_equipment_none = /** @type {(inputs: Profile_Equipment_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada marcado`)
};

const pt_pt2_profile_equipment_none = /** @type {(inputs: Profile_Equipment_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada marcado`)
};

const fr_fr2_profile_equipment_none = /** @type {(inputs: Profile_Equipment_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rien de coché`)
};

const de_de2_profile_equipment_none = /** @type {(inputs: Profile_Equipment_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nichts ausgewählt`)
};

const it_it2_profile_equipment_none = /** @type {(inputs: Profile_Equipment_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niente selezionato`)
};

/**
* | output |
* | --- |
* | "Nothing ticked" |
*
* @param {Profile_Equipment_NoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_equipment_none = /** @type {((inputs?: Profile_Equipment_NoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Equipment_NoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_equipment_none(inputs)
	if (locale === "es-419") return es_419_profile_equipment_none(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_equipment_none(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_equipment_none(inputs)
	if (locale === "de-DE") return de_de2_profile_equipment_none(inputs)
	if (locale === "it-IT") return it_it2_profile_equipment_none(inputs)
	return en_us2_profile_equipment_none(inputs)
});
export { profile_equipment_none as "profile.equipment_none" }